import axios from 'axios'

export default {
    getZone(){
        return axios.get('/zone')
            .then(response => {
                return response.data
            })
    },
    getZoneDataSource(params){
        return axios.get('/zone/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getZonebyID(id){
        return axios.get('/zone/' + id)
            .then(response => {
                return response.data
            })
    },    
    createZone(formdata){
        return axios.post('/zone', formdata)
            .then(response => {
                return response.data
            })
    },
    updateZone(id,formdata){
        return axios.put('/zone/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateZone(id){
        return axios.put('/zone/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateZone(id){
        return axios.put('/zone/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
   
}